export default "__VITE_ASSET__DqXukTsD__"